import { Meteor } from 'meteor/meteor';

export type MethodDeclaration<A, R = undefined> = {
  name: string,
  call: (arg: A) => Promise<R>
}

// Deliberately a leaf module: it is imported by every /imports/api collection module, and importing
// /imports/utils from here closed a cycle (utils → api/miscl → methods → utils) that only resolved when
// utils happened to load first.
/**
 * Builds a typed wrapper around a named Meteor method.
 * @param name - Meteor method name to invoke.
 * @returns A MethodDeclaration whose `call` runs the method with typed arg/result.
 */
export const DeclareMethod = <A, R = undefined>(name: string): MethodDeclaration<A, R> => {
  return {
    name,
    call: (arg: A) => new Promise<R>((resolve, reject) => {
      Meteor.call(name, arg, (error: any, result: R) => (error ? reject(error) : resolve(result)));
    }),
  } as MethodDeclaration<A, R>;
};